/**
 * Routes where a new notification is kept for the bell but not toasted:
 * onboarding (the welcome notification lands before the name is in), the
 * booking screens (they say "You're booked" themselves), and the call
 * (Call ended says what happened; the walk of 28 October had two light
 * toasts over its title). Pure, so tested.
 */
export function quietToastRoute(pathname: string): boolean {
  return pathname.startsWith('/onboarding/') || pathname.startsWith('/request-lesson/') || pathname.startsWith('/call/');
}
